import { Box, ListItem, Typography } from '@mui/material';
import { ShortText } from '../../../../icons/short-text';

import { style } from './style';

type KeyValueItemProps = {
  property: string,
  value: string | null | HistoryValues,
}
export const KeyValueItem = ({
  property,
  value,
}: KeyValueItemProps):JSX.Element => {
  return (
    <ListItem>
      <Box sx={ style.boxContainer.sx }>
        <Box sx={ style.boxContainer.boxRow.sx  }>
          <ShortText />
        </Box>
        <Typography variant={ style.boxContainer.Typography.variant }>
          { property }
        </Typography>
        <Typography
          sx={ style.boxContainer.Typography }
          variant={ style.boxContainer.Typography.variant }
          color={ style.boxContainer.Typography.text }
        >
          {value}
        </Typography>
      </Box>
    </ListItem>
  );
};
